import { render } from "./App.vue?vue&type=template&id=f5ac6eba"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f5ac6eba&lang=css"
script.render = render

export default script